import React from "react";
import '../../App.css';




function Details() {

    return (

        <section>
                <h2>Details</h2>
        </section>
     )
  
}

export default Details;